<template>
      <div class="select-city-wrapper bg-white-pearl">
      <!-- Top Bar with Logo - Now without border and with larger logo -->
      <v-app-bar flat class="logo-bar" height="72">
        <v-img
          :src="require('@/assets/suuq.logo.svg')"
          alt="SUUQ Logo"
          class="logo-img"
          contain
          @click="navigateToHome"
        />
      </v-app-bar>
  
      <!-- Main Content - Centered but compact -->
      <div class="content-container">
        <!-- Greeting Section with exact font styling from reference -->
        <div class="greeting-section">
          <h1 class="greeting-text"> Hello!</h1>
          <p class="instruction-text">Where should we place your ad?</p>
        </div>
  
        <!-- City Selection Section - Now wider with adjusted button height -->
        <div class="selection-section">
          <!-- City dropdown - made wider horizontally -->
          <v-select
            v-model="selectedCitySlug"
            :items="cities"
            label="Select a City"
            item-title="name"
            item-value="slug"
            variant="outlined"
            :loading="isLoadingCities"
            :error-messages="errorMessage"
            hide-details="auto"
            class="city-selector"
            @update:modelValue="handleCitySelection"
          ></v-select>
  
          <!-- Proceed Button - Now half the height of dropdown -->
          <v-btn
            :disabled="!selectedCitySlug"
            @click="proceedToPlaceAd"
           
            size="x-large"
            block
            class="proceed-button mt-4"
            :class="{ 'shake-animation': !selectedCitySlug, 'disabled-button': !selectedCitySlug }"
          >
         <!-- Aan tagno -->
            Let's Go
          </v-btn>
        </div>
      </div>
    </div>
  </template>
  
  <script setup>
  import { ref, computed, onMounted } from "vue";
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  
  const store = useStore();
  const router = useRouter();
  
  // State
  const selectedCitySlug = ref(null);
  
  // Computed properties
  const cities = computed(() => store.getters["NewCategory/cities"]);
  const selectedCity = computed(() => store.getters["NewCategory/selectedCity"]);
  const isLoadingCities = computed(() => store.getters["NewCategory/isLoadingCities"]);
  const errorMessage = computed(() => store.getters["NewCategory/errorMessage"]);
  
  // Lifecycle hook - Fetch cities when component mounts
  onMounted(() => {
    store.dispatch("NewCategory/fetchCities");
  });
  
  // Methods
  const handleCitySelection = (citySlug) => {
  selectedCitySlug.value = citySlug;

  // Find the city object by slug
  const city = cities.value.find((c) => c.slug === citySlug);

  // Dispatch the action with the full city object
  store.dispatch("NewCategory/selectCity", city);
};
  
 const proceedToPlaceAd = () => {
  if (selectedCity.value) {
    router.push({ 
      name: "PlaceAd", 
      query: { city: selectedCity.value.slug } 
    });
  }
};
  
  const navigateToHome = () => {
    router.push({ name: "Home" });
  };
  </script>
  
  <style scoped>
  /* Main wrapper styling */
  .select-city-wrapper {
    min-height: 100vh;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
  }
  
   /* Logo bar styling - Removed border divider */
   .logo-bar {
    background: white !important;
    border-bottom: 1px solid #e0e0e0;
    display: flex;
    justify-content: center;
    padding: 8px 0;
    height: 56px;
  }
  

 /* Fixing the Logo Size */
.logo-img {
  cursor: pointer;
  height: 100%; /* Matches the bar height */
  width: auto;
  max-width: 100%;
}
  
  /* Content container - centered but compact */
  .content-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
  
    flex-grow: 1;
  }
  
  /* Greeting section styling with exact font from reference */
  .greeting-section {
    text-align: center;
    margin-bottom: 14px;
    width: 100%;
  }
  
  .greeting-text {
    margin: 0;
    font-weight: 700;
    font-family: proxima-nova, ProximaNova, noto, var(--my-gess), GESS, GE-SS, sans-serif;
    font-size: 1.25rem; /* 20px equivalent */
    line-height: 1.334;
    color: #333; /* Darker text */
    margin-top: 24px; /* As per reference */
  }
  
  .instruction-text {
    font-size: 16px;
    color: #333; /* Darker text */
    font-weight: 400;
    font-family: proxima-nova, ProximaNova, noto, var(--my-gess), GESS, GE-SS, sans-serif;
    margin-top: 8px;
  }
  
  /* Selection section - now wider (from 33.33% to 50%) */
  .selection-section {
    width: 50%; /* Increased from 33.33% */
    min-width: 320px; /* Slightly wider minimum */
    max-width: 450px; /* Increased max width */
    padding: 0 16px;
  }
  
  /* City selector styling - made slightly taller */
  .city-selector {
    width: 100%;
  }
  
  .city-selector :deep(.v-field) {
    border-radius: 8px;
    border: 1px solid #e0e0e0;
    height: 60px; /* Increased from 56px */
  }
  
  .city-selector :deep(.v-field__input) {
    padding-top: 18px; /* Adjusted for taller field */
    color: #333; /* Darker text */
    transition: color 0.3s ease;
    font-family: proxima-nova, ProximaNova, noto, var(--my-gess), GESS, GE-SS, sans-serif;
  }
    .city-selector :deep(.v-field--active .v-field__input) {
    color: #333; /* Darker text */
    }
    /* Optional: Make the label red when focused */
    .city-selector :deep(.v-field--focused .v-label) {
    color: darkgoldenrod !important;
    }
    
    /* Updated Proceed Button */
    .proceed-button {
        background-color: darkgoldenrod !important; /* Slightly lighter red */
    color: white !important;
    font-weight: 700;
    font-size: 14px;
    height: 35px; 
    border-radius: 8px;
    text-transform: none;
    letter-spacing: 0;
    transition: all 0.3s ease-in-out;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    }
  
/* Hover Effect */
.proceed-button:hover {
  background-color: darkgoldenrod; /* Darker red */
  transform: scale(1.05); /* Slight size increase */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
  
  .proceed-button:active {
    transform: translateY(0);
  }
  /* Disabled button styling */
.disabled-button {
  cursor: not-allowed !important;
  background-color: darkgoldenrod !important; /* Retain original color */
  color: white !important;
  pointer-events: none; /* Disable interactions */
}

/* Prevent hover effects for disabled button */
.disabled-button:hover {
  background-color: darkgoldenrod !important; /* Keep the same color */
  transform: none; /* No hover animation */
  box-shadow: none; /* No shadow effect */
}
  
  /* Shake animation when button is clicked without selection */
  .shake-animation {
    animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
  }
  
  @keyframes shake {
    0%, 100% { transform: translateX(0); }
    10%, 30%, 50%, 70%, 90% { transform: translateX(-5px); }
    20%, 40%, 60%, 80% { transform: translateX(5px); }
  }
  
  /* Responsive adjustments */
  @media (max-width: 768px) {
    .selection-section {
      width: 80%; /* More width on tablets */
      min-width: unset;
    }
    
    .greeting-text {
      font-size: 1.1rem;
    }
  }
  
  @media (max-width: 480px) {
    .content-container {
      padding-top: 24px;
    }
    
    .selection-section {
      width: 90%; /* Full width on mobile */
    }
    
    .logo-img {
      height: 42px; /* Slightly smaller on mobile */
    }
    
    .proceed-button {
      height: 28px; /* Slightly smaller on mobile */
    }
  }


  </style>